import { isHeaderDirty, isUnsavedDetil } from "../../utils/editorHelpers";
import { isMissingRequiredGambar } from "../../utils/checklistProblem";

const checklistGroups = [
  { labelGrup: "bagian_depan", name: "Bagian Depan" },
  { labelGrup: "bagian_samping", name: "Bagian Samping" },
  { labelGrup: "bagian_belakang", name: "Bagian Belakang" },
  { labelGrup: "bagian_dalam", name: "Bagian Dalam" },
];
const checklistTrailerGroup = { labelGrup: "trailer", name: "Trailer" };

const fotoGroups = [
  { labelGrup: "gambar_depan", name: "Tampak Depan" },
  { labelGrup: "gambar_belakang", name: "Tampak Belakang" },
  { labelGrup: "gambar_kiri", name: "Tampak Kiri" },
  { labelGrup: "gambar_kanan", name: "Tampak Kanan" },
];
const fotoTrailerGroups = [
  { labelGrup: "gambar_box_depan", name: "Tampak Box Depan" },
  { labelGrup: "gambar_box_belakang", name: "Tampak Box Belakang" },
  { labelGrup: "gambar_box_kiri", name: "Tampak Box Kiri" },
  { labelGrup: "gambar_box_kanan", name: "Tampak Box Kanan" },
];

// What has to be true before a signature (Transport / Keamanan) can be given, for one side of the trip:
//   1. the header has no unsaved change
//   2. the checklist: every group is saved, the rows that need a photo have one
//   3. the foto: every card has its Foto Asli
//   4. no checklist row / marking was changed or added and left unsaved
// validateBeforeVerify(side) shows the first problem and returns false, true when all is fine.
const useEditorVerifyValidation = ({
  uiContext,
  headerData,
  savedHeader,
  pengecekanSaved,
  pengecekanBerangkatData,
  pengecekanKembaliData,
  pengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  hasTrailer,
}) => {
  const validateBeforeVerify = (side) => {
    const isSideBerangkat = side === "berangkat";
    const pengecekanData = isSideBerangkat
      ? pengecekanBerangkatData
      : pengecekanKembaliData;
    const detils =
      (isSideBerangkat
        ? pengecekanBerangkatDetilData
        : pengecekanKembaliDetilData) ?? [];

    const withTrailer = hasTrailer ? hasTrailer(headerData) : false;
    const nameOf = [
      ...checklistGroups,
      checklistTrailerGroup,
      ...fotoGroups,
      ...fotoTrailerGroups,
    ].reduce((map, group) => ({ ...map, [group.labelGrup]: group.name }), {});

    const showError = (message) => {
      uiContext.showErrorMsg("Error", message);
      return false;
    };

    // 1. header
    if (isHeaderDirty(headerData, savedHeader)) {
      return showError(
        "Data header (bagian atas) berubah dan belum di-save. Save header dulu."
      );
    }

    // 2. checklist
    const checklist = withTrailer
      ? [...checklistGroups, checklistTrailerGroup]
      : checklistGroups;
    const notSaved = checklist.filter(
      (group) => !pengecekanSaved[group.labelGrup]
    );
    if (notSaved.length > 0) {
      return showError(
        `Checklist belum di-save: ${notSaved.map((el) => el.name).join(", ")}`
      );
    }

    const missingGambar = detils.filter(isMissingRequiredGambar);
    if (missingGambar.length > 0) {
      return showError(
        `Foto wajib diisi: ${missingGambar.map((el) => el.keterangan).join(", ")}`
      );
    }

    // 3. foto
    const foto = withTrailer ? [...fotoGroups, ...fotoTrailerGroups] : fotoGroups;
    const noFoto = foto.filter(
      (group) => !(pengecekanData && pengecekanData[group.labelGrup])
    );
    if (noFoto.length > 0) {
      return showError(
        `Foto Asli belum diambil: ${noFoto.map((el) => el.name).join(", ")}`
      );
    }

    // 4. unsaved changes of the checklist rows and the markings
    const unsavedGroups = [
      ...new Set(
        detils.filter(isUnsavedDetil).map((detil) => detil.label_grup)
      ),
    ];
    if (unsavedGroups.length > 0) {
      return showError(
        `Ada perubahan yang belum di-save: ${unsavedGroups
          .map((labelGrup) => nameOf[labelGrup] ?? labelGrup)
          .join(", ")}`
      );
    }

    return true;
  };

  return { validateBeforeVerify };
};

export default useEditorVerifyValidation;
